import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog';
import { useTranslation } from '../../locale/useTranslation';
import * as API from '../../framework/API/api';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { ArrayCell } from '../../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import { DateOnlyCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { DropDownCell } from './ContractCommandCell';
import { CheckboxCell } from '../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import { ENTITYNAME, FILEURL, TOAST_TYPES } from '../../framework/constant/constant';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import ToastNotification from '../../components/ToastNotification';
import { utility } from '../../framework/utility/utilityProvider';

const SyndicateRightReport = ({ item = {}, onClose }) => {
    const lang = useTranslation();
    const [gridData, setGridData] = useState([]);

    useEffect(() => {
        loadData();
    }, [item]);

    const loadData = async () => {
        let syndicateRightRes = await API.getData(ENTITYNAME.MediaDealRights, {
            query: [
                ["ContractSID", "=", item?.SID],
                ["ContractNumber", "=", item?.ContractNumber]
            ],
            sort: { SID: 1 }
        });

        if (syndicateRightRes?.data?.length > 0) {
            const gridRows = [];

            syndicateRightRes.data.forEach((item) => {

                let syndicateRights =
                    typeof item.SyndicateRight === "string"
                        ? JSON.parse(item.SyndicateRight || "[]")
                        : item.SyndicateRight || [];

                if (!Array.isArray(syndicateRights)) {
                    syndicateRights = [syndicateRights];
                }

                syndicateRights.forEach((x) => {
                    gridRows.push({
                        // Only ContractTitle fields
                        Title: item?.ContractTitle?.Title || "",
                        AssetId: item?.ContractTitle?.AssetId || "",
                        MediaCategory: item?.MediaCategory?.Description || "",
                        ...x
                    });
                });
            });

            setGridData(gridRows);
        } else {
            setGridData([]);

            ToastNotification({
                type: TOAST_TYPES.ERROR,
                title: lang.invalid_error_message_title,
                message: lang.invalid_error_message_title
            });
        }
    };
    const downloadExcel = async () => {
        if (gridData.length == 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.no_data_found_error_message });
            return;
        } else {
            let storeData = gridData.map((x) => {
                return {
                    Title: x?.Title || "",
                    AssetId: x?.AssetId || "",
                    MediaCategory: x?.MediaCategory || "",
                    Licensor: x?.Licensor?.Name || "",
                    BroadcastMedium: x?.BroadcastMedium?.Description || x?.BroadcastMedium || "",
                    StartDate: x?.StartDate ? utility.convertMilisecondsToDateString(x?.StartDate) : "",
                    EndDate: x?.EndDate ? utility.convertMilisecondsToDateString(x?.EndDate) : "",
                    Exhibitions: x?.Exhibitions ?? "",
                    Repeats: x?.Repeats ?? "",
                    ExclusiveStartDate: x?.ExclusiveStartDate ? utility.convertMilisecondsToDateString(x?.ExclusiveStartDate) : "",
                    ExclusiveEndDate: x?.ExclusiveEndDate ? utility.convertMilisecondsToDateString(x?.ExclusiveEndDate) : "",
                    BlackoutStartDate: x?.BlackoutStartDate ? utility.convertMilisecondsToDateString(x.BlackoutStartDate) : "",
                    BlackoutEndDate: x?.BlackoutEndDate ? utility.convertMilisecondsToDateString(x.BlackoutEndDate) : "",
                    Currency: x?.Currency?.Description || x?.Currency || "",
                    Amount: x?.Amount ?? "",
                    PlayTimeNumber: x?.PlayTimeNumber ?? "",
                    PlayTime: x?.PlayTime?.Description || x?.PlayTime || ""
                };
            });
            let res = await API.exportCSV(storeData);
            if (res.success) {
                window.open(
                    FILEURL().BASEURL + "downloadReport/" + res.data
                );

                ToastNotification({
                    type: TOAST_TYPES.SUCCESS,
                    title: lang.success_message_title,
                    message: lang.successfully_download_success_message
                });
            } else {
                ToastNotification({
                    type: TOAST_TYPES.ERROR,
                    title: lang.invalid_error_message_title,
                    message: res.message
                });
            }
        }
    };

    return (
        <BossDialog title={lang.syndicate_right_report_dialog_header} onClose={onClose} width='60%'>
            <div className='mb-2'>
                <RoundButton icon='download' onClick={downloadExcel} title={lang.download_button_tooltip} />
            </div>
            <Grid resizable data={gridData} style={{ height: '400px' }}>
                <GridColumn field="Title" title={lang.title_column} width={'150px'} />
                <GridColumn field="AssetId" title={lang.assetId_column} width={'150px'} />
                <GridColumn field="MediaCategory" title={lang.media_category_column} width={'150px'} />
                <GridColumn field="Licensor.Name" title={lang.licensor_column} width={'150px'} />
                <GridColumn field="BroadcastMedium" title={lang.broadcast_medium_column} cell={DropDownCell} width={'150px'} />
                <GridColumn field="StartDate" title={lang.start_date_column} cell={DateOnlyCell} width={'150px'} />
                <GridColumn field="EndDate" title={lang.end_date_column} cell={DateOnlyCell} width={'150px'} />
                <GridColumn field="Exhibitions" title={lang.exhibition_column} width={'150px'} />
                <GridColumn field="Repeats" title={lang.repeat_column} width={'125px'} />
                <GridColumn field="ExclusiveStartDate" title={lang.exclusive_start_date_label} cell={DateOnlyCell} width={'150px'} />
                <GridColumn field="ExclusiveEndDate" title={lang.exclusive_end_date_label} cell={DateOnlyCell} width={'150px'} />
                <GridColumn field="BlackoutStartDate" title={lang.blackout_start_date_label} cell={DateOnlyCell} width={'150px'} />
                <GridColumn field="BlackoutEndDate" title={lang.blackout_end_date_label} cell={DateOnlyCell} width={'150px'} />
                <GridColumn field="Currency" title={lang.currency_column} cell={DropDownCell} width={'150px'} />
                <GridColumn field="Amount" width={'150px'} title={lang.amount_column} />
                <GridColumn field="PlayTimeNumber" title={lang.play_time_number_column} width={'125px'} />
                <GridColumn field="PlayTime" title={lang.playTime_column} cell={DropDownCell} width={'150px'} />
            </Grid>
        </BossDialog>
    )
}

export default SyndicateRightReport